export default {
  empty: "-",
  enteredTransfer: "ENTERED TRANSFER PORTAL",
  entryIntent: "INTENDS TO ENTER",
  philter: "recent-transfers",
  transferred: "TRANSFERRED TO: ",
  withdrew: "WITHDREW BACK TO: "
};
